export const ROLES_HIDE_EDIT = ['admin'];
export const ROLES_HIDE_DELETE = [
  'admin',
  'manager',
  'operator',
  'virtual buddy',
  'inventory owner',
];
